import React, { useEffect, useState } from 'react';
import ModalWrapper from '../../../../elements/ModalWrapper';
import { useDisclosure } from '@mantine/hooks';
import { useMutation, useQuery } from '@tanstack/react-query';
import {
  getDataInterestUser,
  getMasterInterest,
  postInterest
} from '../../../../../services/navbar';
import useLocalStorage from '../../../../../hooks/useUserData';
import { Checkbox, Grid, TagsInput, Text, Textarea } from '@mantine/core';
import { showNotification } from '../../../../../utilities/mantineNotification';
import Button from '../../../../elements/Button';

interface ModalInterestProps {}

const ModalInterest: React.FC<ModalInterestProps> = () => {
  const [userData, setUserData] = useLocalStorage('persist:root', null);
  const profileUser = userData?.auth ? JSON.parse(userData?.auth) : null;

  if (!profileUser) return null;

  const profile = profileUser?.userData;
  const [checkedInterests, setCheckedInterests] = useState({});
  const [otherInterest, setOtherInterest] = useState([]);

  const fetchedDataInterestUser = useQuery({
    queryKey: [`interestUser`],
    queryFn: () => getDataInterestUser(profile?.email),
    enabled: !!profile?.email
  });

  const fetchedMasterInterest = useQuery({
    queryKey: [`masterInterest`],
    queryFn: getMasterInterest,
    enabled:
      fetchedDataInterestUser?.data?.data?.data?.latestPeriodStatus === '0'
        ? false
        : fetchedDataInterestUser?.data?.data?.data?.latestPeriodStatus ===
          undefined
        ? false
        : true
  });

  console.log(
    'LATEST PERIOD STATUS: ' +
      fetchedDataInterestUser?.data?.data?.data?.latestPeriodStatus
  );

  const saveInterest = useMutation({
    mutationFn: postInterest,
    onSuccess: (response) => {
      if (response?.data?.resultCode === 200) {
        showNotification({
          type: 'success',
          title: 'Yeay! we`re saved your interest',
          message: 'We`ll give you best recommendation for you'
        });
        fetchedDataInterestUser.refetch();
        close();
        // refetch
        fetchedDataInterestUser.refetch();
      } else {
        showNotification({
          type: 'error',
          title: 'Oh no! something wrong when saved your interest',
          message:
            response?.data?.errorMessage ||
            'Failed when save interest. Please try again'
        });
      }
    },
    onError: (error) => {
      showNotification({
        type: 'error',
        message: JSON.stringify(error)
      });
    }
  });

  const [opened, { open, close }] = useDisclosure(false);

  const currentUserInterest =
    fetchedDataInterestUser?.data?.data?.data?.currentInterest;
  const masterInterest = fetchedMasterInterest?.data?.data?.data;
  const latestPeriodID =
    fetchedDataInterestUser?.data?.data?.data?.latestPeriodID;
  const currentPeriodID =
    fetchedDataInterestUser?.data?.data?.data?.currentPeriodID;
  const latestStatus =
    fetchedDataInterestUser?.data?.data?.data?.latestPeriodStatus;

  useEffect(() => {
    // Initialize checked state based on currentUserInterest
    if (currentUserInterest?.length > 0) {
      const checkedInterestsMap = {};
      // currentUserInterest.forEach((item) => {
      //   checkedInterestsMap[item.interestID] = true;
      // });
      // setCheckedInterests(checkedInterestsMap);
    }
  }, [currentUserInterest]);

  useEffect(() => {
    if (fetchedDataInterestUser?.data?.data?.data?.latestPeriodStatus === '1') {
      open();
    }
  }, [latestPeriodID, currentPeriodID]);

  const handleSubmit = () => {
    if (
      Object.values(checkedInterests).filter(Boolean).length +
        otherInterest.length >
      3
    ) {
      showNotification({
        type: 'error',
        title: 'Oh no! something wrong when saved your interest',
        message: 'Please select a maximum of 3 topics of interest'
      });
      return;
    }

    const otherInterestString = otherInterest.join(', ');

    const selectedInterests = masterInterest.filter(
      (item) => checkedInterests[item.id]
    );

    const _toStringData = JSON.stringify(selectedInterests);
    const _normalizeData = _toStringData.replace(/\\/g, '');

    const parsedData = JSON.parse(_normalizeData);
    const normalizedData = parsedData.map((item) => ({ id: item.id }));

    const _toStringNormalizeData = JSON.stringify(normalizedData);
    const _passData = _toStringNormalizeData.replace(/\\/g, '');

    const payload = {
      email: profile?.email,
      dataJson: _passData,
      otherInterests: otherInterestString,
      targetInterestPeriodID: latestPeriodID
    };

    // console.log(payload);

    saveInterest.mutate(payload);
  };

  const disabledChecked = () => {
    return Object.values(checkedInterests).filter(Boolean).length === 3;
  };

  const disabled = () => {
    return Object.values(checkedInterests).filter(Boolean).length < 1;
  };

  const handleCheckboxChange = (interestID) => {
    if (
      Object.values(checkedInterests).filter(Boolean).length < 3 ||
      checkedInterests[interestID]
    ) {
      setCheckedInterests((prevState) => ({
        ...prevState,
        [interestID]: !prevState[interestID]
      }));
    }
  };

  return (
    <>
      <ModalWrapper
        title="Before we get started, we’d like to ask a few questions to 
  better understand your business needs."
        isVisible={opened}
        withCloseButton={false}
        onClose={() => close()}
        size={'xl'}
      >
        <Text className="text-md-bold">
          What type of topics you like to heard?
        </Text>
        <Text className="text-xs-medium text-grey-80">
          Please select a maximum of 3 topics of interest that are appropriate
          for you{' '}
          <b
            style={{
              color:
                Object.values(checkedInterests).filter(Boolean).length +
                  otherInterest.length ===
                3
                  ? 'green'
                  : 'red'
            }}
          >
            (
            {Object.values(checkedInterests).filter(Boolean).length +
              otherInterest.length}{' '}
            of 3 selected)
          </b>
        </Text>

        <Grid gutter={8} my={24}>
          {masterInterest?.length > 0 &&
            masterInterest.map((item, index) => {
              return (
                <Grid.Col key={index} span={{ base: 12, md: 4 }}>
                  <Checkbox
                    mt={10}
                    checked={checkedInterests[item.id] || false}
                    label={item.name}
                    disabled={disabledChecked() && !checkedInterests[item.id]}
                    onChange={() => handleCheckboxChange(item.id)}
                  />
                </Grid.Col>
              );
            })}
        </Grid>
        {Object.values(checkedInterests).filter(Boolean).length === 3 ? null : (
          <TagsInput
            value={otherInterest}
            mb={10}
            onChange={(value) => setOtherInterest(value)}
            required
            label="Another Interest?"
            description={`(THIS IS OPTIONAL) Please write down your interest here if there is none of your interest in the list above, and use comma (,) to separate each interest"
          placeholder="Ex: Movie, Cooking, etc`}
            maxTags={5}
            placeholder="Enter Interest (separated by comma)"
            splitChars={[',']}
          />
        )}

        <Button onClick={handleSubmit} disabled={disabled()}>
          Submit
        </Button>
      </ModalWrapper>
    </>
  );
};

export default ModalInterest;
